import React, { useEffect, useState } from "react";
import Navbar from "../../_Layouts/Navbar/Navbar";
import MachineHistorique from "../../Components/Machines/MachineHistorique";
import { useAppDispatch } from "../../_App/Redux/hooks";
import { findHistorique } from "../../_App/Redux/Slices/historique/historiqueSlice";
import { findTodayAndFutureOdfs } from "../../_App/Redux/Slices/odfs/odfSlice";
import { useParams } from "react-router-dom";
import { findMachineProgs } from "../../_App/Redux/Slices/plannings/planningsSlice";
import {
  findTickets,
  findTicketsImage,
} from "../../_App/Redux/Slices/tickets/ticketSlice";
import {
  findIntervention,
  findinterventionImages,
  findMouvements,
  findObjets,
} from "../../_App/Redux/Slices/interventions/interventionSlice";
import moment from "moment";

const HistoriquePage = () => {
  let { code } = useParams();
  const [startDate, setStartDAte] = useState(
    moment().startOf("day").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("day").format("YYYY-MM-DD")
  );

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (code) {
      dispatch(
        findHistorique({ machineCode: code, start: startDate, end: endDate })
      );
      dispatch(findMachineProgs(code));
      dispatch(findTickets({ start: startDate, end: endDate }));
      dispatch(findTicketsImage(null));
      dispatch(findIntervention(null));
      dispatch(findinterventionImages(null));
      dispatch(findObjets(null));
      dispatch(findMouvements(null));
    }
  }, [startDate, endDate, dispatch]);
  return (
    <div>
      <Navbar titre={"Historique"} />
      <div className="page-container">
        <MachineHistorique
          start={startDate}
          setStart={setStartDAte}
          end={endDate}
          setEnd={setEndDate}
        />
      </div>
    </div>
  );
};

export default HistoriquePage;
